"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canWalk = void 0;
const WorldCharacter_1 = require("../classes/WorldCharacter");
const WorldMenu_1 = require("../classes/WorldMenu");
const state_1 = require("../state");
const definables_1 = require("definables");
const getWorldState_1 = require("./state/getWorldState");
const canWalk = () => {
    if (state_1.state.values.worldState === null) {
        return false;
    }
    const worldState = (0, getWorldState_1.getWorldState)();
    const worldCharacter = (0, definables_1.getDefinable)(WorldCharacter_1.WorldCharacter, worldState.values.worldCharacterID);
    const partyLeaderWorldPlayerID = worldCharacter.player.character.party.playerIDs[0];
    if (typeof partyLeaderWorldPlayerID === "undefined") {
        throw new Error("No party leader.");
    }
    if (partyLeaderWorldPlayerID !== worldCharacter.playerID) {
        return false;
    }
    for (const worldMenu of (0, definables_1.getDefinables)(WorldMenu_1.WorldMenu).values()) {
        if (worldMenu.preventsWalking && worldMenu.isOpen()) {
            return false;
        }
    }
    return true;
};
exports.canWalk = canWalk;
